import { ErrorResponse } from '../interfaces/type'

type Props = {
    id: string
    message: string
    error: ErrorResponse | null
    handleModal: () => void
    handleSubmitModal: (id: string) => void
}

const DeleteModal = ({ id, message, error, handleModal, handleSubmitModal }: Props) => {

    const handleSubmit = () => {
        handleSubmitModal(id)
    }

    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-full my-6 mx-auto md:max-w-xl">
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                            <h3 className="text-xl font-semibold">
                                Eliminar Usuario
                            </h3>
                            <button
                                onClick={handleModal}
                                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                            >
                                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                </span>
                            </button>
                        </div>
                        <div className="relative p-6 flex-auto font-semibold text-lg text-gray-600">
                            {message}
                        </div>
                        {/*footer*/}
                        <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                            <button
                                onClick={handleModal}
                                className="text-gray-500 background-transparent font-bold uppercase px-5 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button"
                            >
                                Cerrar
                            </button>
                            <button
                                onClick={handleSubmit}
                                className="bg-red-500 text-white hover:bg-red-700 font-bold uppercase text-sm px-5 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button"
                            >
                                Eliminar
                            </button>
                        </div>
                        {
                            error &&
                            <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                                <div>{`${error.error}: ${error.errorDetail}`}</div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default DeleteModal